import FooterLite from './FooterLite'

export { FooterLite }

export default{
  FooterLite
}



/** WEBPACK FOOTER **
 ** ../app/components/common/lite/index.js
 **/